module.exports = __webpack_public_path__ + "static/media/Advisors-close.0e1a6512.svg";